import * as actionTypes from '../actions/actionTypes';
import { FeatureFlagsActions } from '../../types/actiontypes/featureFlagsActions';
import { FeatureFlags } from '../../utils/constants';

export type FeatureFlagsReducer = FeatureFlags;

export const initialState: FeatureFlagsReducer = {
  FEATURE_FLAG_CIAM_MFA_ENABLED: false,
  FEATURE_FLAG_FILTER_ASSETS_WAITING_FOR_RETURN_ENABLED: false,
  FEATURE_FLAG_FRONTEND_FLOW_BUYOUT_WITH_PRICE_ENABLED: false,
  FEATURE_FLAG_MAINTENANCE_MODE_ENABLED: false,
  FEATURE_FLAG_PIM_AND_USER_GROUP_ROLES_ENABLED: false,
  FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_NO_ENABLED: false,
};

const reducer = (state: FeatureFlagsReducer = initialState, action: FeatureFlagsActions): FeatureFlagsReducer => {
  if (action.type === actionTypes.FEATURE_FLAGS_SET) {
    return { ...action.featureFlags };
  }
  return state;
};

export default reducer;
